import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { firmInfo } from '../../i18n/translations';

const Footer = ({ t, scrollToSection }) => {
  return (
    <footer className="bg-navy-900 text-white py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-5 mb-4">
              <div className="h-24 w-24 flex-shrink-0">
                <img 
                  src="/logo-icon.png" 
                  alt="Mediation Partners Icon" 
                  className="w-full h-full object-contain"
                  style={{ 
                    filter: 'brightness(0) invert(1)'
                  }}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold text-white leading-tight">
                  Mediation Partners
                </span>
                <span className="text-xs text-gray-300 leading-tight">
                  Mediation and advisory for complex situations
                </span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">{t.nav.about}</button></li>
              <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">{t.nav.services}</button></li>
              <li><button onClick={() => scrollToSection('team')} className="hover:text-white transition-colors">{t.nav.team}</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors">{t.nav.contact}</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t.footer.contact}</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a href={`mailto:${firmInfo.email}`} className="hover:text-white transition-colors">
                  {firmInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a href={`tel:${firmInfo.phone}`} className="hover:text-white transition-colors">
                  {firmInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-700 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} {firmInfo.name}. {t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;